import Localization from '../../other/localization';

const localization = new Localization();

if (typeof window !== 'undefined' && $.validator) {
    $.validator.addMethod(
        'accept',
        (value) => !!value,
        localization.getMessage('validation-message-accept'),
    );

    $.validator.addMethod(
        'select',
        (value) => !!value,
        localization.getMessage('validation-message-select'),
    );

    $.validator.addMethod(
        'regex',
        (value, element, params) => (
            value.length === 0
            || new RegExp(params).test(value)
        ),
        localization.getMessage('validation-message-regex'),
    );

    $.validator.addMethod(
        'regex_exclude',
        (value, element, params) => (
            value.length > 0
            || !new RegExp(params).test(value)
        ),
        localization.getMessage('validation-message-regex'),
    );

    $.validator.addMethod(
        'customEmail',
        (value) => {
            // Pl.:
            //     test@gmail.com
            //     test@test-tested.test.dev.test.com
            //     test+tested-rrere+dads~~~~das@test-tested.test.dev.test.com
            //     "very.(),:;<>[]\".VERY.\"very@\\\"very\".unusual"@strange.com
            //     postmaster@[123.123.123.123]
            //     "john..doe"@example.org
            const emailRegex = (
                // eslint-disable-next-line no-control-regex
                /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
            );

            return !!value.match(emailRegex);
        },
        localization.getMessage('email_format'),
    );

    $.validator.addMethod(
        'companyTaxNumber',
        (value) => {
            const regExp = /[a-zA-Z]/g;
            const matched = (
                value.match(regExp)
                || $('.tax-num-2').val().match(regExp)
                || $('.tax-num-3').val().match(regExp)
            );
            return !matched;
        },
        localization.getMessage('validation-message-number'),
    );

    $.validator.addMethod(
        'companyTaxRequired',
        (value) => {
            const matched = (
                value.length === 0
                || $('.tax-num-2').val().length === 0
                || $('.tax-num-3').val().length === 0
            );
            return !matched;
        },
        localization.getMessage('validation-message-required'),
    );

    $.validator.addMethod(
        'companyTaxOnlyEmptyFirst',
        (value) => (
            !(
                $('.tax-num-2').val().length !== 0
                && $('.tax-num-3').val().length !== 0
                && value.length === 0
            )
        ),
        localization.getMessage('tax_number_first_part_minlength'),
    );
    $.validator.addMethod(
        'companyTaxOnlyEmptySecond',
        (value) => (
            !(
                value.length !== 0
                && $('.tax-num-3').val().length !== 0
                && $('.tax-num-2').val().length === 0
            )
        ),
        localization.getMessage('tax_number_second_part_minlength'),
    );
    $.validator.addMethod(
        'companyTaxOnlyEmptyThird',
        (value) => (
            !(
                value.length !== 0
                && $('.tax-num-2').val().length !== 0
                && $('.tax-num-3').val().length === 0
            )
        ),
        localization.getMessage('tax_number_third_part_minlength'),
    );
    $.validator.addMethod(
        'companyTaxChecksum',
        (value) => {
            const multiples = [9, 7, 3, 1, 9, 7, 3];
            let sum = 0;
            for (let i = 0; i < 7; i++) {
                sum += multiples[i] * parseInt(value[i], 10);
            }
            const checkSum = parseInt(value[7], 10) === 0 ? 10 : parseInt(value[7], 10);

            return checkSum === 10 - (sum % 10);
        },
        localization.getMessage('invalid_tax_number'),
    );

    $.validator.addMethod(
        'dateMustBeSelected',
        (value) => (value !== '---'),
        localization.getMessage('date-must-be-selected'),
    );

    $.validator.addMethod(
        'newsLetterRequired',
        (value) => parseInt(value, 10) >= 0,
        localization.getMessage('validation_newsletter_required'),
    );
}
